"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CheckoutStepsSettings = void 0;
var _checkoutBasket = require("@ori/checkout-basket");
var _checkoutNotifications = require("@ori/checkout-notifications");
var _checkoutOffers = require("@ori/checkout-offers");
var _react = require("react");
var _skeletons = require("../components/skeletons");
var _models = require("../models");
var _TranslationKey = require("../models/TranslationKey");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const LazyBasketStep = /*#__PURE__*/ (0, _react.lazy)(async ()=>Promise.resolve().then(()=>_interopRequireWildcard(require('../components/BasketStep'))));
const LazyOffersStep = /*#__PURE__*/ (0, _react.lazy)(async ()=>Promise.resolve().then(()=>_interopRequireWildcard(require('../components/OffersStep'))));
const LazyCheckoutStep = /*#__PURE__*/ (0, _react.lazy)(async ()=>Promise.resolve().then(()=>_interopRequireWildcard(require('../components/CheckoutStep/CheckoutStep'))));
const CheckoutStepsSettings = exports.CheckoutStepsSettings = {
    [_models.ShoppingStep.Basket]: {
        Step: LazyBasketStep,
        StepSkeleton: _checkoutBasket.BasketStepSkeleton,
        metaHierarchy: _models.MetaHierarchy.Basket,
        navigationButtonTestId: _models.TestId.BasketNavigationButton,
        stepLabelKey: _TranslationKey.TranslationKey.basket,
        virtualPage: _models.VirtualPage.Basket,
        notificationTypes: [
            _checkoutNotifications.NotificationAppearance.ShopppingBag,
            _checkoutNotifications.NotificationAppearance.All
        ]
    },
    [_models.ShoppingStep.Offers]: {
        Step: LazyOffersStep,
        StepSkeleton: _checkoutOffers.OfferStepSkeleton,
        metaHierarchy: _models.MetaHierarchy.Offers,
        navigationButtonTestId: _models.TestId.OffersNavigationButton,
        stepLabelKey: _TranslationKey.TranslationKey.offers,
        virtualPage: _models.VirtualPage.Offers,
        notificationTypes: [
            _checkoutNotifications.NotificationAppearance.Offers,
            _checkoutNotifications.NotificationAppearance.All
        ]
    },
    [_models.ShoppingStep.Checkout]: {
        Step: LazyCheckoutStep,
        StepSkeleton: _skeletons.CheckoutStepSkeleton,
        metaHierarchy: _models.MetaHierarchy.Review,
        navigationButtonTestId: _models.TestId.CheckoutNavigationButton,
        stepLabelKey: _TranslationKey.TranslationKey.checkout,
        virtualPage: _models.VirtualPage.Review,
        notificationTypes: [
            _checkoutNotifications.NotificationAppearance.Delivery,
            _checkoutNotifications.NotificationAppearance.Payments,
            _checkoutNotifications.NotificationAppearance.Review,
            _checkoutNotifications.NotificationAppearance.All
        ]
    }
};
